<div class="flex flex-col w-[360px] items-start gap-[10px] relative">
    <div class="flex h-[43px] items-center p-2 self-stretch w-full bg-light-grey-2 rounded-[8px] gap-4">
      <i class="fa fa-search text-neutral-400 ml-1"></i>
      <input type="text"
        [value]="value"
        (input)="handleSearch($event)"
        class="relative flex-1 font-normal placeholder:text-light-grey-3 text-[17px] tracking-[-0.41px] leading-[22px] bg-transparent focus:outline-none"
        placeholder="Search"
        aria-label="Search" />
    </div>
  </div>